import VueRouter from 'vue-router';
import Cookies from 'js-cookie';
import components from '../components/index.js';

export default {
  setup: function (store) {
    const routes = [

      {
        path: '*',
        name: '404',
        component: components.NotFound
      },
      {
        path: '/',
        name: 'root',
        redirect: '/products'
      },
      {
        path: '/products',
        name: 'products',
        component: components.TheProducts
      },
      {
        path: '/products/:id',
        name: 'productDetails',
        component: components.ProductDetails,
        props: true
      },
      {
        path: '/products/menu/:id',
        name: 'menuDetails',
        component: components.MenuDetails,
        props: true
      },
      {
        path: '/orders',
        name: 'orders',
        component: components.OrderHistory
      },
      {
        path: '/login',
        name: 'login',
        component: components.TheLogin
      }
    ];

    const router = new VueRouter({
      mode: 'history',
      routes
    });

    router.beforeEach(loadUser);

    async function loadUser (to, from, next) {
      if (to.query?.sso) {
        await store.dispatch('validateUser', to.query.sso);
        delete to.query.sso;
      } else if (!store.state.userToken) {
        await store.dispatch('initializeAuth');
      }

      const toLogin = to.path === '/login';
      const token = Cookies.get('user-token');
      const isAuthenticated = store.getters.isAuthenticated || token;

      if (toLogin && isAuthenticated) {
        next('/');
      } else if (!toLogin && !isAuthenticated) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        });
      } else {
        next();
      }
    }
    return router;
  }
};
